import React from 'react';
import ItemDetails, { Field } from '../containers/itemDetails';
import Layout from '../hoc/layout';
import { BOOKS } from '../utils/constants';
import { string } from 'prop-types';

const BookItem = ({ itemId }) => (
  <Layout>
    <ItemDetails
      itemId={itemId}
      itemType={BOOKS}
    >
      <Field field='numberOfPages' label='Number of Pages' />
      <Field field='publisher' label='Publisher' />
      <Field field='released' label='Released' />
    </ItemDetails>
  </Layout>
)

BookItem.propTypes = {
  itemId: string,
}

export default BookItem